import * as React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink";
import { LearnMoreResources, OverviewContainer, OverviewHighlightText, TopicsContainer } from "../../CommonComponents/CommonViews";
export const ProjectDeploymentsSettingsHelp = () => {
    return (<OverviewContainer>
            <OverviewHighlightText>
                <p>The settings on this page control how releases are created and deployed.</p>
            </OverviewHighlightText>
        </OverviewContainer>);
};
export const ProjectDeploymentsSettingsTopics = () => {
    return (<TopicsContainer>
            <LearnMoreResources>
                <div>
                    <ExternalLink href="ConfigAsCodeEditing">Editing version-controlled projects</ExternalLink>
                </div>
            </LearnMoreResources>
        </TopicsContainer>);
};
